// Copyright 1999-2020. Plesk International GmbH. All rights reserved.

export const PLESK_COOKIES = 'https://docs.plesk.com/en-US/obsidian/cookies';
export const CONTROL_COOKIES = 'https://docs.plesk.com/en-US/obsidian/delete-cookies';



// WEBPACK FOOTER //
// ./app/cookie-policy/urls.js